class GeoFeatureLineOrArea {
    constructor(id, coordinates, mapGeometryType, color, name) {
        this.id = id;
        this.coordinates = coordinates;
        this.mapGeometryType = mapGeometryType;
        this.color = color;
        this.name = name;
    }
}
export default GeoFeatureLineOrArea;
